import { Button } from '@shared/ui/kit';
import styles from './preview-summary-section.module.scss';
import { PreviewChannelsList } from './preview-channels-list';
import type { PreviewChannel } from './preview-channels-item';

export interface DeliverySummary {
  channels: PreviewChannel[];
  deliveryLabel: string;
  dateSelected: boolean;
}

interface PreviewSummarySectionProps {
  onSendClick?: () => void;
  isSendDisabled?: boolean;
  eventName: string | null;
  eventDateLabel: string;
  invitesCount: number;
  ticketsCount: number;
  shouldShowTickets: boolean;
  invitationSummary: DeliverySummary;
  ticketSummary: DeliverySummary;
}

export const PreviewSummarySection = ({
  onSendClick,
  isSendDisabled = false,
  eventName,
  eventDateLabel,
  invitesCount,
  ticketsCount,
  shouldShowTickets,
  invitationSummary,
  ticketSummary,
}: PreviewSummarySectionProps) => {
  return (
    <div className={styles.previewPanel}>
      <section className={styles.previewBody}>
        <header className={styles.previewEventHeader}>
          <h2 className={styles.previewEventTitle}>{eventName}</h2>
          <div className={styles.previewEventMeta}>
            <p className={styles.previewEventMetaText}>{eventDateLabel}</p>
          </div>
        </header>
        <div className={styles.previewDivider} />
        <section className={styles.previewSummaryCard}>
          <div className={styles.previewSummaryHeader}>
            <h3 className={styles.previewSummaryTitle}>Будет отправлено</h3>
            <p className={styles.previewSummaryTotals}>
              <span className={styles.previewSummaryTotalItem}>
                <span className={styles.previewSummaryTotalCount}>{invitesCount}</span>
                <span className={styles.previewSummaryTotalText}>приглашений</span>
              </span>
              {shouldShowTickets && (
                <>
                  <span className={styles.previewSummaryTotalText}>и</span>
                  <span className={styles.previewSummaryTotalItem}>
                    <span className={styles.previewSummaryTotalCount}>{ticketsCount}</span>
                    <span className={styles.previewSummaryTotalText}>билетов</span>
                  </span>
                </>
              )}
            </p>
          </div>
          <section className={styles.previewDeliverySection}>
            <div className={styles.previewDeliveryRow}>
              <h3 className={styles.previewDeliveryTitle}>Приглашения</h3>
              <div
                className={
                  invitationSummary.dateSelected ? styles.previewDeliveryStatusSelected : styles.previewDeliveryStatus
                }
              >
                <p
                  className={
                    invitationSummary.dateSelected
                      ? styles.previewDeliveryStatusTextSelected
                      : styles.previewDeliveryStatusText
                  }
                >
                  {invitationSummary.deliveryLabel}
                </p>
              </div>
            </div>
            <PreviewChannelsList channels={invitationSummary.channels} />
          </section>
          {shouldShowTickets && (
            <section className={styles.previewDeliverySection}>
              <div className={styles.previewDeliveryRow}>
                <h3 className={styles.previewDeliveryTitle}>Билеты</h3>
                <div
                  className={
                    ticketSummary.dateSelected ? styles.previewDeliveryStatusSelected : styles.previewDeliveryStatus
                  }
                >
                  <p
                    className={
                      ticketSummary.dateSelected
                        ? styles.previewDeliveryStatusTextSelected
                        : styles.previewDeliveryStatusText
                    }
                  >
                    {ticketSummary.deliveryLabel}
                  </p>
                </div>
              </div>
              <PreviewChannelsList channels={ticketSummary.channels} />
            </section>
          )}
        </section>
      </section>
      <Button
        variant="accent"
        size="medium"
        onClick={onSendClick}
        isDisabled={isSendDisabled}
        settings={{
          width: '100%',
          fontFamily: 'var(--font-family-din-regular)',
          fontSize: '18px',
        }}
      >
        Отправить
      </Button>
    </div>
  );
};
